/* eslint-disable react/prop-types */
import React from 'react';
import { Switch } from 'react-router';
import { Route, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import intersection from 'lodash/intersection';
import { silentAuthCheck } from './redux/actions';

const DefaultLayout = () => {
  return (
    <div>MISSING LAYOUT</div>
  );
};

const hasRole = (userRoles, routeRoles) => {
  if (intersection(userRoles, Array.isArray(routeRoles) ? routeRoles : [routeRoles]).length > 0) return true;
  return false;
};

const MakeRoute = ({
  path, component: Component, role, layout = 'default', layouts, forceLogin, unauthenticatedDefault, invalidRoleRedirect, children, routes, ...rest
}) => {
  // NOTE don't use getAuthHook as it will trigger updates whenever the redux state changes
  const { user, isLoggingIn, silentFailure } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const renderRoute = (props) => {
    const RouteLayout = layouts[layout] ?? DefaultLayout;
    let subRoutes = children;
    if (role) {
      // in process of logging in, no action
      if (!user && isLoggingIn) return null;

      if (!user && forceLogin) {
        // They aren't authenticated but the app wants to force a sign in (otherwise it will just redirect to the home page)
        if (!silentFailure) {
          dispatch(silentAuthCheck(forceLogin));
          return;
        }
      }

      // This page needs a certain role for it to load
      if (!user || (user && !user.roles)) {
        // They are either not logged in or logged in, but don't have this role
        return <Redirect to={{ pathname: unauthenticatedDefault || '/' }} />;
      }
      if (!hasRole(user.roles, role)) {
        return <Redirect to={{ pathname: invalidRoleRedirect || '/' }} />;
      }

      // Remove any child routes that have a role they aren't valid for
      if (children) {
        subRoutes = children.map((child) => {
          if (child.role && !hasRole(user.roles, child.role)) return;
          return child;
        }).filter((x) => x);
      }
    }

    return React.cloneElement(RouteLayout, {
      page: Component && <Component {...props} routes={children} />,
      routes,
      childRoutes: subRoutes,
      ...props,
    });
  };

  return (
    <Route path={path} {...rest} render={renderRoute} />
  );
};

export const RouteManager = ({
  routes, layouts, unauthenticatedDefault, forceLogin, invalidRoleRedirect
}) => {
  return (
    <Switch>
      { routes.map((route) => <MakeRoute key={route} layouts={layouts} routes={routes} forceLogin={forceLogin} unauthenticatedDefault={unauthenticatedDefault} invalidRoleRedirect={invalidRoleRedirect} {...route} />)}
    </Switch>
  );
};
